import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../../services/analyticsService';

export const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes
    console.log('Tracking page view:', location.pathname);
    analyticsService.trackEvent({
      eventType: 'pageview',
      category: 'Navigation',
      action: 'Page View',
      data: {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        title: document.title,
        referrer: document.referrer,
        url: window.location.href
      }
    });
  }, [location]);

  return null;
};